import {
  IProcessFlowMappedVariable, IProcessFlowSubmissionMappedVariable,
  IProcessFlowVariableMap
} from "~/interfaces/processFlowInterfaces"
import IRepo from '~/interfaces/repo'
import Repo from '~/state/modules/repo'
import ObjectModelTrigger from "../../models/objectModelTriggers/objectModelTrigger";
import BuilderModel from "~/models/tracked/builderModel";
import {ModelType} from "~/enums/modelType";
import ObjectModelAction from "~/models/objectModelActions/objectModelAction";

type parentTypes = ObjectModelTrigger | ObjectModelAction;
export default class ProcessFlowSubmissionMappedVariable extends BuilderModel implements IProcessFlowSubmissionMappedVariable {
  source_id: string;
  process_flow_variable_id: string;
  source_type: ModelType;

  // ******************** RELATIONS AND REPOS ******************** //
  static repo: IRepo<ProcessFlowSubmissionMappedVariable> = new Repo<ProcessFlowSubmissionMappedVariable>('processFlowSubmissionMappedVariables', ProcessFlowSubmissionMappedVariable, {});
  repo: IRepo<this>;

  // parent is an ObjectModelTrigger for now, will need to eventually add workflow steps and actions when ready
  constructor(parent: parentTypes, json = {}) {
    super();
    this.defineClientId();
    this._nameInParent = 'process_flow_submission_mapped_variables'
    this.loadFromJson(json, parent.rootModel);
  }

  get rootName(): string {
    return this._nameInParent;
  }

  static cloneMappedVariables(variables, parent: parentTypes): Array<ProcessFlowSubmissionMappedVariable> {
    return variables.reduce((acc, variable) => {
      let map = parent.processFlowSubmissionMappedVariables.find(val => val.process_flow_variable_id === variable.id);
      let omId = map?.source_id;

      map = new ProcessFlowSubmissionMappedVariable(parent, {process_flow_variable_id: variable.id, source_id: omId});

      acc.push(map);

      return acc;
    }, []);
  }

  static setMappedVariables(variableMaps, parent: parentTypes) {
    // for now safest to wipe mapping and replace with new values so that removed variables don't remain
    this.destroyAll(parent);

    const mapObj = variableMaps.reduce((obj, v) => {
      v.parent = parent;
      v.rootModel = parent.rootModel;
      parent.trackCreationDeletion(v.client_id, null, v.asJson(), v);
      obj[v.client_id] = v;
      return obj;
    }, {})

    parent.process_flow_submission_mapped_variables = mapObj;
  }

  static destroyAll(parent: parentTypes) {
    Object.values(parent.process_flow_submission_mapped_variables).forEach(v => {
      v.destroy();
    })
  }
}